import { useResourceFetch, useResourceFetchOne } from '@gandi/resource/react';
import { createSequoiaResource } from '@gandi/resource/redux';
export const getIdentifierFrom201 = response => response.data.uuid;
export const API_URL = '/templates/templates';
export const templateResource = createSequoiaResource('template', 'templates', {
  fetchPath: API_URL,
  fetchOnePath: `${API_URL}/{id}`,
  statePath: 'template2'
});

// --- Hooks

export const useTemplateList = query => {
  // $FlowFixMe[incompatible-call]: number => mixed
  return useResourceFetch(templateResource, query);
};
export const prefetchList = ({
  query,
  dispatch
}) => {
  return dispatch(templateResource.fetch(templateResource.options.fetchPath, {
    // $FlowFixMe[incompatible-call]
    params: query,
    label: templateResource.computeLabel(templateResource.options.fetchPath,
    // $FlowFixMe[incompatible-call]: type mixed
    query)
  }));
};
export const useTemplate = uuid => {
  return useResourceFetchOne(templateResource, {
    id: uuid
  });
};
export const prefetchOne = ({
  id,
  dispatch
}) => {
  return dispatch(templateResource.fetchOne(templateResource.options.fetchOnePath, {
    params: {
      id
    },
    label: templateResource.computeLabel(templateResource.options.fetchOnePath, {
      id
    })
  }));
};